import { ProductDetailThemeSizeConfig } from './types';

const medium: ProductDetailThemeSizeConfig = {
  productDetail: {},
};

export default medium;
